import {
  REQUEST_CONTROL_POINTS,
  RESPONSE_CONTROL_POINTS,
  REQUEST_CONTROL_POINTS_FAILURE,
  REQUEST_CREATE_CONTROL_POINT,
  RESPONSE_CREATE_CONTROL_POINT,
  REQUEST_CREATE_CONTROL_POINT_FAILURE,
  REQUEST_DELETE_CONTROL_POINT,
  RESPONSE_DELETE_CONTROL_POINT,
  REQUEST_DELETE_CONTROL_POINT_FAILURE,
  ON_SELECT_CONTROL_POINT,
  ON_UNSELECT_CONTROL_POINT,
  REQUEST_UPDATE_CONTROL_POINT,
  RESPONSE_UPDATE_CONTROL_POINT,
  REQUEST_UPDATE_CONTROL_POINT_FAILURE,
} from "../actions/controlPointActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  logisticControlPointsDataState: queriesStates.NOT_REQUESTED,
  logisticControlCreatePointsDataState: queriesStates.NOT_REQUESTED,
  logisticControlDeletePointsDataState: queriesStates.NOT_REQUESTED,
  logisticControlUpdatePointsDataState: queriesStates.NOT_REQUESTED,
  logisticSelectedControlPoint: null,
  logisticControlPoints: [],
  logisticControlPointsGroups: [],
  logisticLastControlPoint: null,
  errors: [],
};

const logisticControlPointsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CONTROL_POINTS: {
      return Object.assign({}, state, {
        logisticControlPointsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CONTROL_POINTS: {
      return Object.assign({}, state, {
        logisticControlPointsDataState: queriesStates.READY,
        logisticControlPoints: action.data.controlPoints,
        logisticControlPointsGroups: action.data.logisticGroups,
        logisticLastControlPoint: action.data.controlPoints.length > 0 ? action.data.controlPoints[action.data.controlPoints.length - 1] : null,
      });
    }
    case REQUEST_CONTROL_POINTS_FAILURE: {
      return Object.assign({}, state, {
        logisticControlPointsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_CONTROL_POINT: {
      return Object.assign({}, state, {
        logisticControlCreatePointsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_CONTROL_POINT: {
      const _logisticSelectedControlPoint = state.logisticSelectedControlPoint;

      _logisticSelectedControlPoint.id = action.data.id;

      return Object.assign({}, state, {
        logisticControlCreatePointsDataState: queriesStates.READY,
        logisticControlPoints: state.logisticControlPoints.concat(action.data),
        logisticSelectedControlPoint: _logisticSelectedControlPoint,
      });
    }
    case REQUEST_CREATE_CONTROL_POINT_FAILURE: {
      return Object.assign({}, state, {
        logisticControlCreatePointsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_CONTROL_POINT: {
      return Object.assign({}, state, {
        logisticControlDeletePointsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_CONTROL_POINT: {
      return Object.assign({}, state, {
        logisticControlDeletePointsDataState: queriesStates.READY,
        logisticControlPoints: state.logisticControlPoints.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    }
    case REQUEST_DELETE_CONTROL_POINT_FAILURE: {
      return Object.assign({}, state, {
        logisticControlDeletePointsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case ON_SELECT_CONTROL_POINT: {
      const _point = Object.assign({}, action.data, {});

      return Object.assign({}, state, {
        logisticSelectedControlPoint: _point,
      });
    }

    case ON_UNSELECT_CONTROL_POINT: {
      return Object.assign({}, state, {
        logisticSelectedControlPoint: null,
      });
    }

    case REQUEST_UPDATE_CONTROL_POINT: {
      return Object.assign({}, state, {
        logisticControlUpdatePointsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_UPDATE_CONTROL_POINT: {
      return Object.assign({}, state, {
        logisticControlUpdatePointsDataState: queriesStates.READY,
        logisticSelectedControlPoint: action.data,
        logisticControlPoints: state.logisticControlPoints.map((x) => {
          if (x.id === action.data.id) {
            return action.data;
          }

          return x;
        }),
        logisticLastControlPoint: action.data,
      });
    }
    case REQUEST_UPDATE_CONTROL_POINT_FAILURE: {
      return Object.assign({}, state, {
        logisticControlUpdatePointsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default logisticControlPointsReducer;
